
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/attractions-activities",
      function () {
        return require("private-next-pages/business/attractions-activities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/attractions-activities"])
      });
    }
  